module.exports = __webpack_public_path__ + "img/step-3.d35d629b.png";